import { Component } from 'react';
import SurveyHeader from './surveyHeader';
import Footer from './surveyFooter';
import i18n from 'src/utils/translate';
import SwipeableViews from 'react-swipeable-views';
import classNames from 'classnames';

type Props = {
  className?: string;
  hideClose?: boolean;
  hideHeader?: boolean;
  hideNext?: boolean;
  isNextButtonDisabled?: boolean;
  progress: number;
  screens: Screen[];
  onClose?: (currentPosition: number) => void;
  onFinish?: (acceptResearch?: boolean) => Promise<void>;
  onNext?: () => void;
  onPositionChanged: (index: number, history: number[]) => void;
  renderScreen: (screen: Screen) => JSX.Element;
}
type State = {
  currentPosition: number;
  history: number[];
}
export type Screen = {
  id: number;
  key: string;
  title: string;
  content: JSX.Element;
  buttonText?: string;
}
export default class Survey extends Component<Props, State> {

  static defaultProps = {
    screens: [],
    progress: 0,
    isNextButtonDisabled: false,
    onClose: () => {},
    onPositionChanged: () => {},
    renderScreen: () => {},
  };

  isIphoneSafari: any;

  constructor(props) {
    super(props);
    this.state = {
      currentPosition: 0,
      history: [],
    };

    this.isIphoneSafari = screen.width <= 768
      && window.navigator.userAgent.match(/iPhone/i) && window.navigator.userAgent.match(/AppleWebKit/);
  }

  componentDidMount() {
    if (this.isIphoneSafari) {
      window.document.body.classList.add('hack-show-safari-bars__body');
      window.document.getElementsByTagName('html')[0].classList
        .add('hack-show-safari-bars__html');
    }
  }

  componentWillUnmount() {
    if (this.isIphoneSafari) {
      window.document.body.classList.remove('hack-show-safari-bars__body');
      window.document.getElementsByTagName('html')[0].classList
        .remove('hack-show-safari-bars__html');
    }
  }

  restoreState = ({ currentPosition, history }) => {
    this.setState({ currentPosition, history });
  }

  goToScreen = (key) => {
    const { screens } = this.props;
    const screen = screens.find(x => x.key === key);
    if (!screen) return;
    const index = screens.indexOf(screen);
    this.goToPosition(index);
  }

  goToPosition = (index) => {
    this.setState(state => {
      const history = [...state.history, state.currentPosition];
      this.props.onPositionChanged(index, history);
      return {
        currentPosition: index,
        history,
      };
    });
  }

  resetHistoryTo = (newHistoryArray) => {
    this.setState({ history: newHistoryArray });
  }

  goBack = () => {
    this.setState(state => {
      const lastIndex = state.history[this.state.history.length - 1];
      const history = state.history.slice(0, state.history.length - 1);
      this.props.onPositionChanged(lastIndex, history);
      return {
        currentPosition: lastIndex,
        history,
      };
    });
  }

  goToNext = () => {
    const { screens, onFinish } = this.props;
    const isLastScreen = this.state.currentPosition === screens.length - 1;
    if (!isLastScreen) {
      this.goToPosition(this.state.currentPosition + 1);
    } else if (isLastScreen && onFinish) {
      onFinish();
    }
  }

  onNext = () => {
    const { onNext } = this.props;
    if (onNext) {
      onNext();
      return;
    }
    this.goToNext();
  }

  getButtonText = () => {
    const { screens } = this.props;
    const isLastScreen = this.state.currentPosition === screens.length - 1;
    const buttonText = screens[this.state.currentPosition].buttonText;
    if (buttonText) return buttonText;
    return isLastScreen
      ? i18n.t('Done')
      : i18n.t('Next');
  }

  render() {
    const { onClose, screens, progress, isNextButtonDisabled, renderScreen, hideHeader, hideNext, hideClose, className } = this.props;
    const buttonText = this.getButtonText();
    const surveyClasses = classNames({
      'survey': true,
      [className]: !!className,
    });
    return (
      <div className={surveyClasses}>
        {!hideHeader && (
          <SurveyHeader
            hideBack={hideHeader || this.state.currentPosition === 0}
            hideClose={hideHeader || hideClose}
            onBack={this.goBack}
            onClose={() => onClose(this.state.currentPosition)}
          />
        )}
        <div className="survey__body">
          <SwipeableViews
            animateTransitions={true}
            className="react-swipeable-views"
            disabled={true}
            index={this.state.currentPosition}
          >
            {screens.map(renderScreen)}
          </SwipeableViews>
        </div>
        <Footer
          buttonText={buttonText}
          disabled={isNextButtonDisabled}
          hideNext={hideNext}
          progress={progress}
          onClickNext={this.onNext}
        />
      </div>
    );
  }
}
